import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { InterventionCenterGovStatistics } from '../../../common/types/statistics/fhbfStatistics';

type Props = {
  statistics: InterventionCenterGovStatistics;
};

function NumberOfPersonalAccompaniment({ statistics }: Props) {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'block',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            7 Anzahl der persönlichen Begleitungen{' '}
            <span className='font-size-small'>
              <b>(persönliche Begleitung erfolgt i.d.R. nur, soweit für die pro-aktive Beratung notwendig)</b>
            </span>
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem' align='right' border='2px solid black' px='5px' py='15px'>
            {statistics.numberOfTypeAccompaniment}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default NumberOfPersonalAccompaniment;
